'use strict';
'use es6';

// Prevent unwanted focus styles

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _Functions = require('../core/Functions');

var _validHref = require('../utils/propTypes/validHref');

var _validHref2 = _interopRequireDefault(_validHref);

var _UnsafeUrl = require('../utils/UnsafeUrl');

var _Links = require('../utils/Links');

var _TabIndex = require('../utils/TabIndex');

var _LinkConstants = require('./LinkConstants');

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UITruncateString = require('../text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _ClickableContext = require('../context/ClickableContext');

var _component = require('../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Hide icon in tables, except on hover (#5679)
var truncatedExternalIconMixin = (0, _styledComponents.css)(['.private-table tr:not(:hover) .private-link:not(:focus) &{visibility:hidden;}']);

var DefaultExternalIcon = (0, _styledComponents2.default)(function (props) {
  var __truncated = props.truncated,
      rest = _objectWithoutProperties(props, ['truncated']);

  return _react2.default.createElement(_UIIcon2.default, rest);
}).withConfig({
  displayName: 'UILink__DefaultExternalIcon'
})(['', ''], function (_ref) {
  var truncated = _ref.truncated;
  return truncated && truncatedExternalIconMixin;
});

var getClassName = function getClassName(className, disabled, underline, use) {
  return (0, _classNames2.default)('private-link', _LinkConstants.UNDERLINE_CLASSES[underline], _LinkConstants.USE_CLASSES[use], { 'private-link--disabled': disabled }, className);
};

var UILinkCore = _react2.default.createClass({
  displayName: 'UILinkCore',

  mixins: [_reactAddonsPureRenderMixin2.default],

  handleKeyDown: function handleKeyDown(evt) {
    // Simulate click on Spacebar, to emulate button behavior
    var key = evt.key;
    var _props = this.props,
        disabled = _props.disabled,
        onKeyDown = _props.onKeyDown,
        onClick = _props.onClick;


    (0, _Functions.callIfPossible)(onKeyDown, evt);

    if (typeof onClick !== 'function') {
      return;
    }

    if (key === ' ') {
      if (disabled) {
        evt.preventDefault();
        evt.stopPropagation();
        return;
      }
      onClick(evt);

      // Prevent scrolling
      evt.preventDefault();
    }
  },
  handleClick: function handleClick(evt) {
    var _props2 = this.props,
        onClick = _props2.onClick,
        disabled = _props2.disabled;


    if (disabled) {
      evt.preventDefault();
      evt.stopPropagation();
    } else {
      (0, _Functions.callIfPossible)(onClick, evt);
    }
  },
  render: function render() {
    var _props3 = this.props,
        children = _props3.children,
        className = _props3.className,
        disabled = _props3.disabled,
        external = _props3.external,
        ExternalIcon = _props3.ExternalIcon,
        href = _props3.href,
        iconProps = _props3.iconProps,
        linkRef = _props3.linkRef,
        __onClick = _props3.onClick,
        __onKeyDown = _props3.onKeyDown,
        rel = _props3.rel,
        role = _props3.role,
        tabIndex = _props3.tabIndex,
        target = _props3.target,
        truncate = _props3.truncate,
        truncateStringProps = _props3.truncateStringProps,
        underline = _props3.underline,
        use = _props3.use,
        rest = _objectWithoutProperties(_props3, ['children', 'className', 'disabled', 'external', 'ExternalIcon', 'href', 'iconProps', 'linkRef', 'onClick', 'onKeyDown', 'rel', 'role', 'tabIndex', 'target', 'truncate', 'truncateStringProps', 'underline', 'use']);

    if (this.props.to != null) {
      _devLogger2.default.warn({
        message: 'UILink: The `to` prop is a no-op. Did you mean `href`? (`to="' + this.props.to + '"`)',
        key: 'UILink: to'
      });
    }

    var computedTarget = (0, _Links.getTarget)(external, target);
    var computedRel = (0, _Links.getRel)(rel, computedTarget);
    var computedRole = href ? undefined : role || 'button';
    var externalLinkIcon = external ? _react2.default.createElement(ExternalIcon, _extends({
      'aria-label': _I18n2.default.text('salesUI.UILink.externalTitle'),
      name: 'externalLink'
    }, iconProps, {
      className: (0, _classNames2.default)('private-link--external__icon', iconProps.className),
      truncated: truncate
    })) : null;

    (0, _Links.warnIfShouldBeExternal)(external, computedTarget, 'UILink');

    var wrappedChildren = truncate ? _react2.default.createElement(
      _UITruncateString2.default,
      _extends({
        useFlex: true,
        fixedChildren: externalLinkIcon
      }, truncateStringProps),
      children
    ) : children;

    var renderedLink = _react2.default.createElement(
      'a',
      _extends({}, rest, {
        className: getClassName(className, disabled, underline, use),
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        href: disabled ? undefined : (0, _UnsafeUrl.getSafeUrl)(href),
        ref: (0, _Functions.wrapRefObject)(linkRef),
        rel: computedRel,
        role: computedRole,
        tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex),
        target: computedTarget,
        'aria-disabled': disabled
      }),
      wrappedChildren,
      truncate ? null : externalLinkIcon
    );

    return (0, _Links.renderSecurityTaggedLink)(href, renderedLink);
  }
});

UILinkCore.displayName = 'UILink';

var UILink = function (_React$Component) {
  _inherits(UILink, _React$Component);

  function UILink(props) {
    _classCallCheck(this, UILink);

    var _this = _possibleConstructorReturn(this, (UILink.__proto__ || Object.getPrototypeOf(UILink)).call(this, props));

    _this._linkRef = _react2.default.createRef ? _react2.default.createRef() : { current: null };
    _this.getPortalReporterDetails = _this.getPortalReporterDetails.bind(_this);
    return _this;
  }

  _createClass(UILink, [{
    key: 'getPortalReporterDetails',
    value: function getPortalReporterDetails() {
      var linkEl = this._linkRef.current;
      return {
        componentName: UILinkCore.displayName,
        labelText: linkEl && linkEl.innerText
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _ClickableContext.ClickableContextProvider,
        {
          value: (0, _ClickableContext.makePortalReporter)(this.getPortalReporterDetails)
        },
        _react2.default.createElement(UILinkCore, _extends({ linkRef: this._linkRef }, this.props))
      );
    }
  }]);

  return UILink;
}(_react2.default.Component);

UILink.propTypes = {
  children: _react.PropTypes.node,
  disabled: _react.PropTypes.bool,
  external: _react.PropTypes.bool.isRequired,
  ExternalIcon: _component2.default.isRequired,
  href: _validHref2.default,
  iconProps: _react.PropTypes.object.isRequired,
  onKeyDown: _react.PropTypes.func,
  rel: _react.PropTypes.string,
  target: _react.PropTypes.string,
  truncate: _react.PropTypes.bool.isRequired,
  truncateStringProps: _react.PropTypes.object.isRequired,
  underline: _react.PropTypes.bool.isRequired,
  use: _react.PropTypes.oneOf(Object.keys(_LinkConstants.USE_CLASSES)).isRequired
};

UILink.defaultProps = {
  external: false,
  ExternalIcon: DefaultExternalIcon,
  iconProps: {},
  truncate: false,
  truncateStringProps: {},
  underline: false,
  use: 'dark'
};

UILink.displayName = 'ProvidesClickableContext(UILink)';

// Expose the inner component for tests
UILink.CoreComponent = UILinkCore;
UILink.WrappedComponent = UILinkCore;

exports.default = UILink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/link/UILink.js
// module id = 34
// module chunks = 3 4 5